<template>
  <button
    :slot="customSlot"
    :type="type"
    :class="[customClass, `btn-direction--${direction}`]"
    class="btn-direction"
    @click="handleClick"
  >
    <Icon :icon="icon" />
  </button>
</template>

<script>
export default {
  name: "DirectionButton",
  components: {
    Icon: () => import("../elements/Icon"),
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    propsHandleClick: {
      type: Function,
      default: null,
    },
    direction: {
      type: String,
      default: "next", // prev (prev-down), next (prev-down), prev-up, next-up
    },
    customClass: {
      type: String,
      default: null,
    },
    customSlot: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick(value) {
      if (this.propsHandleClick) this.propsHandleClick(value);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.btn-direction {
  display: block;
  position: relative;
  transition: opacity 0.2s;
  width: 3.5rem;
  height: 3.5rem;
  margin: 0;
  border: 0;
  // background-color: $corporateBlue;
  box-shadow: none;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:after {
    display: none;
  }

  &--prev,
  &--prev-down {
    .icon {
      transform: translate(-75%, -50%);
    }
  }

  &--prev-up {
    .icon {
      transform: translate(-75%, -50%);
    }
  }

  &--next,
  &--next-down {
    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-top: 3.5rem solid $accentBlue;
      border-right: 1rem solid transparent;
      right: -1rem;
      top: 0;
      bottom: 0;
    }

    .icon {
      transform: translate(-25%, -50%);
    }
  }

  &--next-up {
    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-bottom: 3.5rem solid $accentBlue;
      border-right: 1rem solid transparent;
      right: -1rem;
      top: 0;
      bottom: 0;
    }

    .icon {
      transform: translate(-25%, -50%);
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &.swiper-button-disabled,
  &.disabled,
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .icon {
    position: absolute;
    left: 50%;
    top: 50%;
  }
}
</style>
